import React from 'react';

import DocumentsIcon from '@atlaskit/icon/glyph/documents';
import DownloadIcon from '@atlaskit/icon/glyph/download';
import RefreshIcon from '@atlaskit/icon/glyph/refresh';
import TrashIcon from '@atlaskit/icon/glyph/trash';

import Spinner from '@atlaskit/spinner';

import './index.css'


function ActionsBar(props) {
  const {
    loading,
    onDelete,
    onDownload,
    onMove,
    onRefresh,
    showLoading
  } = props;

  const showActions = !!onRefresh || showLoading || onDelete || onDownload;

  return (
    <div>
      {showActions &&
        <div className='actions__action-container'>
          { loading &&
            <span className='actions__action-container__icon'>
              <Spinner size={'medium'}/>
            </span>
          }
          {onDownload &&
            <span onClick={onDownload} className='actions__action-container__icon'>
              <DownloadIcon size={'medium'}/>
            </span>
          }
          {onDelete &&
            <span onClick={onDelete} className='actions__action-container__icon actions__action-container__icon--delete'>
              <TrashIcon size={'medium'}/>
            </span>
          }
          { onMove &&
            <span onClick={onMove} className='actions__action-container__icon'>
              <DocumentsIcon size={'medium'}/>
            </span>
          }
          { onRefresh &&
            <span onClick={onRefresh} className='actions__action-container__icon'>
              <RefreshIcon size={'medium'}/>
            </span>
          }
        </div>
      }
    </div>
  );
}

export default ActionsBar;